<template>
	<div class="w1200 flex myinfo">
		<choice-menu></choice-menu>
		<div class="flex flex-direction align-stretch benben-flex-layout myinfo_1">
			<div class="myinfo_2">{{$t('设置')}}</div>
			<div class="flex benben-flex-layout flex-wrap align-center wrap" v-loading="loading"  :element-loading-text="$t('拼命加载中')">
				<div class="system_1 pointer" @click="caozuo(1)">
					<div class="flex benben-flex-layout flex-wrap align-center system_2">
						<div class="flex-sub system_2_1">{{$t('修改登录密码')}}</div>
						<img class="system_2_2" src="https://api.ezlunch.club/pc/image/35.png" alt="" srcset="">
					</div>
					<img class="system_3" src="https://api.ezlunch.club/pc/image/40.png" alt="" srcset="">
				</div> 
				<div class="system_1 pointer" @click="caozuo(3)" v-if=" userInfo.email!=''">
					<div class="flex benben-flex-layout flex-wrap align-center system_2">
						<div class="flex-sub system_2_1">{{$t('修改绑定邮箱号')}}</div>
						<img class="system_2_2" src="https://api.ezlunch.club/pc/image/35.png" alt="" srcset="">
					</div>
					<img class="system_3" src="https://api.ezlunch.club/pc/image/40.png" alt="" srcset="">
				</div>
				<div class="system_1 pointer" @click="caozuo(2)" v-if=" userInfo._mobile!=''">
					<div class="flex benben-flex-layout flex-wrap align-center system_2">
						<div class="flex-sub system_2_1">{{$t('修改绑定手机号')}}</div>
						<img class="system_2_2" src="https://api.ezlunch.club/pc/image/35.png" alt="" srcset="">
					</div>
					<img class="system_3" src="https://api.ezlunch.club/pc/image/40.png" alt="" srcset="">
				</div>
				<div class="flex flex-direction flex-wrap align-stretch justify-between benben-flex-layout pointer system_1" style="padding: 12px 0 0 0 ;">
					<div class="flex benben-flex-layout flex-wrap align-center">
						<div class="flex-sub system_4">
							<div class="system_4_1">{{$t('自动划扣')}}</div>
							<div class="system_4_2">{{$t('当饭票低于')}}5{{$t('张的时候，自动充值')}}</div>
						</div>
						<el-switch 
						  @change="post68e481f4338e7"
						  class="addresDetal_4_1"
						  v-model="input5"
						  active-color="#13ce66">
						</el-switch>
					</div>
					<img class="system_3s" src="https://api.ezlunch.club/pc/image/40.png" alt="" srcset="" style="margin: 18px 0 0 0 ;">
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import ChoiceMenu from "../components/choiceMenu.vue"
	export default {
		components: {
			ChoiceMenu
		},
		data() {
			return {
				input5:true,
				userInfo:'',
				loading:true,
			}
		},
		created() {
			if(window.sessionStorage.getItem('token')){
				this.post5c78c4772da97()
			}else{
				this.$router.push({
					name: 'login',
				});
			}
		},

		methods: {
			gengxin(){
				this.loading = true
				this.post5c78c4772da97()
			},
			post68e481f4338e7(){
				this.$api.post(this.$apiUrls.post68e481f4338e7,{auto_deduction:this.input5}).then((res) => {
					if(res.code == 1){
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			//个人中心-获取会员详细信息
			post5c78c4772da97(){
				this.$api.post(this.$apiUrls.post5c78c4772da97).then((res) => {
					if(res.code == 1){
						this.userInfo = res.data
						this.input5 = this.userInfo.auto_deduction
						this.loading = false
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			caozuo(type){
				let url = ''
				if(type == 1){
					url = 'password'
				}else if(type == 2){
					url = 'phone'
				}else if(type == 3){
					url = 'email'
				}
				this.$router.push({
					name: url,
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-loading-mask {
			opacity: 1 !important; 
			background-color: rgba(255, 255, 255, 1) !important;
		}
	}
	.myinfo{
		margin-top: 20px;
	}
	.myinfo_1{
		width: 980px;
		margin: 0 0 0 220px;
		padding:0 20px 100px;
		background: #fff;
		box-sizing: border-box;
	}
	.myinfo_2{
		padding: 20px 0;
		border-bottom: 1px solid #EEEEEE;
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.system_1{
		width: 454px;
		
		margin: 0 32px 0 0;
	}
	.system_1:nth-child(2n) {
		margin: 0 0 0 0;
	}
	.system_1:nth-child(4) {
		height: 80px;
	}
	.system_2{
		padding: 23px 0;
	}
	.system_2_1{
		font-weight: 400;
		font-size: 16px;
		color: #333333;
	}
	.system_2_2{
		width: 20px;
		height: 20px;
	}
	.system_3{
		width: 100%;
	}
	.system_3s{
		width: 100%;
		margin: auto 0 0 0;
	}
	.system_4{
		// margin: 12px 0 13px 0;
	}
	.system_4_1{
		font-weight: 400;
		font-size: 16px;
		color: #333333;
	}
	.system_4_2{
		font-weight: 400;
		font-size: 14px;
		color: #8C8C8C;
		margin: 4px 0 0 0;
	}
</style>